import { observable, computed } from "mobx";
import { AsyncStore } from "src/stores";

export class AsyncState<T extends AsyncStore<T>> {
  @observable
  private _states: (keyof T)[] = [];

  // readonly
  get states(): (keyof T)[] {
    return this._states;
  }

  @computed
  get isEmpty(): boolean {
    return this._states.length === 0;
  }

  @computed
  get notEmpty(): boolean {
    return !this.isEmpty;
  }

  get has(): { [P in keyof T]: boolean } {
    const toObject = this._states.reduce((all, current) => {
      return {
        ...all,
        [current]: true,
      };
    }, {});
    return toObject as any;
  }

  addState(stateIdentifier: keyof T) {
    if (this._states.includes(stateIdentifier)) {
      if (process.env.NODE_ENV === "development") {
        const err = new Error();
        console.warn(
          `Duplicate state identifier detected \`${stateIdentifier}\``,
          err.stack
        );
      }
      return;
    }
    this._states.push(stateIdentifier);
  }

  removeState(stateIdentifier: keyof T) {
    this._states = this._states.filter((s) => s !== stateIdentifier);
  }

  reset() {
    console.warn("Resetting AsyncState property in runtime is ill-advised");
    this._states = [];
  }
}
